<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0">
      <v-row>
        <v-col class="text-start">
          <v-btn color="secondary" outlined to="/admin/courses">
            <v-icon class="mr-1" small>fa-chevron-left</v-icon>Back to Full
            Course Library
          </v-btn>
        </v-col>
        <v-col class="text-end">
          <v-btn
            outlined
            color="primary"
            @click.prevent="showAddQuestionPanel"
            class="add-course-button"
          >
            Add Question
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <h1>
            {{ quiz.course_name }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="Full-Course-Library-Title">
          Questions
          <span style="font-size: 10px; color: #162b44" class="pl-4">
            <v-btn
              @click.prevent="editAgreeStatement"
              class="mr-1 action-button action-button-txt"
              outlined
              small
            >
              <span>Test Settings</span>
            </v-btn>
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': ''}"></v-skeleton-loader>
          <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            v-show="!loading"
            :items="questions"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
            }"
          >
           <template v-slot:item.question_type="{ item }">
                {{ getQuestionTypeName(item.question_type) }}
           </template>
            <template v-slot:item.correct_answer="{ item }">
                {{ getCorrectAnswer(item)  }}
           </template>
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on"
                    class="Frame-61 mr-1"
                    text
                    x-small
                    @click.prevent="showEditQuestionPanel(item.id)"
                  >
                    <v-icon small>fa fa-edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit Question</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="$improve-grey-900"
                    class="Frame-61 mr-1"
                    text
                    x-small
                    @click.prevent="deleteQuestion(item.id)"
                  >
                    <v-icon small>fa fa-trash</v-icon>
                  </v-btn>
                </template>
                <span>Delete Question</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!--<v-row>
                <v-col md="12" class="text-right pa-2">
                    All tests must have a minimum of 10 questions in order to be published
                </v-col>
            </v-row>-->
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import AddQuestion from '@/components/admin/course/tests/AddQuestion';
import EditQuestion from '@/components/admin/course/tests/EditQuestion';
import EditPassmark from '@/components/admin/course/tests/EditPassmark';
import AddAgreeStatement from '@/components/admin/course/tests/AddAgreeStatement';
import { EventBus } from '@/event-bus.js';
import Test from '@/components/authenticated/courses/Test';
import testAPI from '@/api/test.js';
export default {
  name: 'TestAdmin',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Question', value: 'question', sortable: false },
        { text: 'Type', value: 'question_type', sortable: false },
        { text: 'Correct Answer', value: 'correct_answer', sortable: false },
        { text: 'Core', value: 'is_core', sortable: false },
        { text: '', value: 'id', sortable: false, align: 'end' },
      ],
      id: this.$route.params.id,
      questions: [],
      quiz: {},
      pagination: {},
      loading: false,
      options: {},
      selected: [],
      successMessage: 'Question Deleted',
      errorMessage: 'Question not deleted',
      questionTypeOptions: [
        {
          id: 1,
          name: "Single Choice"
        },
        {
          id: 2,
          name: "Fill in the Blank"
        },
        {
          id: 3,
          name: "Multiple Choice"
        },
        {
          id: 4,
          name: "Association"
        }

      ],
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: {
      get() {
        return this.$gf.getQueryString(this.options, this.serverItemsLength);
      },
      set(newValue) {
        return newValue
      }
    },
    selectedQuestions: function () {
      return this.selected.map((x) => {
        return x.id;
      });
    },
    passMark: function () {
      return this.quiz.pass_mark;
    },
    ActionText: function () {
      if (this.quiz.agree_statement == '' || this.quiz.agree_statement == null)
        return 'Add';
      else return 'Edit';
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getQuestions();
      },
      deep: true,
    },
  },
  mounted() {
    this.getQuiz();
    this.setEventBus();
  },
  methods: {
    showTest() {
      this.$showPanel({
        component: Test,
        props: {
          quizId: this.id,
        },
        openOn: 'right',
      });
    },
    editPassmark() {
      this.$showPanel({
        component: EditPassmark,
        props: {
          id: this.quiz.id,
          passMark: this.passMark,
        },
        openOn: 'right',
      });
    },
    getQuestions() {
      this.loading = true;
      testAPI.getQuestions(this.id, this.params).then((resp) => {
        this.questions = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    getQuiz() {
      testAPI.getTest(this.id).then((resp) => {
        this.quiz = resp.data.data;
      });
    },
    deleteSelected() {
      testAPI.deleteQuestions(this.selectedQuestions).then(() => {
        this.selected = [];
        this.getQuestions();
      });
    },
    deleteQuestion(id) {
      testAPI.deleteQuestion(id).then(() => {
        this.getQuestions();
      });
    },
    setEventBus() {
      EventBus.$on('QUESTIONS_UPDATED', (payload) => {
        this.params = payload;
        this.getQuestions();
      });
      EventBus.$on('PASSMARK_UPDATED', (payload) => {
        this.quiz = payload;
      });
    },
    showEditQuestionPanel(id) {
      this.$showPanel({
        component: EditQuestion,
        props: {
          id: id,
          quizId: this.id,
        },
        openOn: 'right',
      });
    },
    showAddQuestionPanel() {
      this.$showPanel({
        component: AddQuestion,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    editAgreeStatement() {
      this.$showPanel({
        component: AddAgreeStatement,
        props: {
          id: this.quiz.id,
        },
        openOn: 'right',
      });
    },
    getQuestionTypeName(id) {
      const match = this.questionTypeOptions.find(option => option.id === id);
      return match ? match.name : "Unknown";
    },
    getCorrectAnswer(question){
      if(question.question_type == 1){
          return question.correct_answer.toUpperCase();
        }
        else if(question.question_type == 2){
          return question.a;
        }
        else if(question.question_type == 3){
          const result = question.correct_answer
            .filter(Boolean)                    
            .map(item => item.toUpperCase())     
            .join(", ");                          

          return result
        }
        else if(question.question_type == 4){
          var answer = question.f + ' , ' + question.g;
          if(question.h != ''){
            answer +=  ' , ' + question.h;
          }
           if(question.i != ''){
            answer +=  ' , ' + question.i;
          }
          if(question.j != ''){
            answer +=  ' , ' + question.j;
          }
          return answer;
        }
    }
  },
};
</script>
